import '~/js/modules/stickyNav';
import SpaTreatments from '~/js/components/spa-treatments/SpaTreatments';

// Variable Declaration
const treatments = document.getElementById('spa-treatments');

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const defaultResortCode = urlParams.get('resort');

// Render react component
ReactDOM.render(<SpaTreatments 
    defaultResortCode={defaultResortCode}
/>, treatments);
